// import {
//   doc,
//   getDoc,
//   updateDoc,
//   deleteDoc,
//   setDoc,
//   collection,
//   getDocs,
//   serverTimestamp,
// } from "firebase/firestore";
// import Swal from "sweetalert2";
// import { db } from "../firebase";

// /* ================= MAIN HANDLER ================= */
// export const handleDeleteFine = async (userId, fineId, amount, status, fetchData) => {
//   try {
//     const docRef = doc(db, "appSetupAction", "1");
//     const docSnap = await getDoc(docRef);

//     if (!docSnap.exists()) {
//       console.error("appSetupAction/1 not found");
//       return;
//     }

//     const { allowDisallow } = docSnap.data();

//     if (allowDisallow === true) {
//       await deleteFineRuleWise(userId, fineId, amount, status, fetchData);
//     } else {
//       await deleteFine(userId, fineId, amount, status, fetchData);
//     }
//   } catch (error) {
//     console.error("Error fetching allowDisallow:", error);
//   }
// };





// /* ================= NORMAL DELETE ================= */
// const deleteFine = async (userId, fineId, amount, status, fetchData) => {
//   const result = await Swal.fire({
//     title: "Delete Fine",
//     text: "Are you sure you want to delete this fine?",
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonText: "Yes, delete it",
//     confirmButtonColor: "#d33",
//   });

//   if (!result.isConfirmed) return;

//   try {
//     const fineRef = doc(db, "Fines", userId, "fines", fineId);
//     const parsedAmount = parseFloat(amount) || 0;

//     await deleteDoc(fineRef);

//     const userRef = doc(db, "Fines", userId);
//     const userDoc = await getDoc(userRef);

//     if (userDoc.exists()) {
//       const data = userDoc.data();

//       const updates = {
//         TotalFine: Math.max(0, (data.TotalFine || 0) - parsedAmount),
//         lastUpdated: serverTimestamp(),
//       };

//       if (status === "Pending") {
//         updates.PendingFine = Math.max(0, (data.PendingFine || 0) - parsedAmount);
//       }

//       await updateDoc(userRef, updates);
//     }

//     Swal.fire("Deleted", "Fine deleted successfully", "success");
//     fetchData && fetchData();
//   } catch (error) {
//     Swal.fire("Error", error.message, "error");
//   }
// };





// /* ================= RULE WISE DELETE ================= */
// const deleteFineRuleWise = async (userId, fineId, amount, status, fetchData) => {
//   const result = await Swal.fire({
//     title: "Delete Fine",
//     text: "Are you sure you want to delete this fine?",
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonText: "Yes delete",
//     confirmButtonColor: "#d33",
//   });

//   if (!result.isConfirmed) return;

//   try {
//     const fineRef = doc(db, "Fines", userId, "fines", fineId);
//     const parsedAmount = parseFloat(amount) || 0;

//     const finesCollection = collection(db, "Fines", userId, "fines");
//     const finesSnapshot = await getDocs(finesCollection);

//     const fineDocs = [];
//     let targetFineDate = null;

//     finesSnapshot.forEach((docSnap) => {
//       const data = docSnap.data();
//       fineDocs.push({ id: docSnap.id, ...data });

//       if (docSnap.id === fineId && data.date) {
//         targetFineDate = new Date(data.date);
//       }
//     });

//     await deleteDoc(fineRef);

//     const userRef = doc(db, "Fines", userId);
//     const userDoc = await getDoc(userRef);

//     if (userDoc.exists()) {
//       const data = userDoc.data();

//       const updates = {
//         TotalFine: Math.max(0, (data.TotalFine || 0) - parsedAmount),
//         lastUpdated: serverTimestamp(),
//       };

//       if (status === "Pending") {
//         updates.PendingFine = Math.max(0, (data.PendingFine || 0) - parsedAmount);
//       }

//       await updateDoc(userRef, updates);
//     }

//     Swal.fire("Deleted", "Fine deleted successfully", "success");
//     fetchData && fetchData();

//   } catch (error) {
//     Swal.fire("Error", error.message, "error");
//   }
// };






// import {
//   doc,
//   getDoc,
//   updateDoc,
//   deleteDoc,
//   setDoc,
//   collection,
//   getDocs,
//   serverTimestamp,
//   runTransaction,
// } from "firebase/firestore";
// import Swal from "sweetalert2";
// import { db } from "../firebase";

// /* ================= MAIN HANDLER ================= */
// export const handleDeleteFine = async (userId, fineId, amount, status, fetchData) => {
//   try {
//     const docRef = doc(db, "appSetupAction", "1");
//     const docSnap = await getDoc(docRef);

//     if (!docSnap.exists()) {
//       console.error("appSetupAction/1 not found");
//       return;
//     }

//     const { allowDisallow } = docSnap.data();

//     if (allowDisallow === true) {
//       await deleteFineRuleWise(userId, fineId, amount, status, fetchData);
//     } else {
//       await deleteFine(userId, fineId, amount, status, fetchData);
//     }
//   } catch (error) {
//     console.error("Error fetching allowDisallow:", error);
//   }
// };

// /* ================= NORMAL DELETE ================= */
// const deleteFine = async (userId, fineId, amount, status, fetchData) => {
//   const result = await Swal.fire({
//     title: "Delete Fine",
//     text: "Are you sure you want to delete this fine?",
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonText: "Yes, delete it",
//     confirmButtonColor: "#d33",
//   });

//   if (!result.isConfirmed) return;

//   try {
//     const fineRef = doc(db, "Fines", userId, "fines", fineId);
//     const parsedAmount = parseFloat(amount) || 0;

//     await deleteDoc(fineRef);

//     const userRef = doc(db, "Fines", userId);
//     const userDoc = await getDoc(userRef);

//     if (userDoc.exists()) {
//       const data = userDoc.data();

//       const updates = {
//         TotalFine: Math.max(0, (data.TotalFine || 0) - parsedAmount),
//         lastUpdated: serverTimestamp(),
//       };

//       if (status === "Pending") {
//         updates.PendingFine = Math.max(0, (data.PendingFine || 0) - parsedAmount);
//       }

//       await updateDoc(userRef, updates);
//     }

//     Swal.fire("Deleted", "Fine deleted successfully", "success");
//     fetchData && fetchData();
//   } catch (error) {
//     Swal.fire("Error", error.message, "error");
//   }
// };

// const deleteFineRuleWise = async (userId, fineId, amount, status, fetchData) => {
//   const result = await Swal.fire({
//     title: "Delete Fine",
//     text: "Are you sure you want to delete this fine?",
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonText: "Yes delete",
//     confirmButtonColor: "#d33",
//   });

//   if (!result.isConfirmed) return;

//   const parsedAmount = parseFloat(amount) || 0;

//   try {
//     await runTransaction(db, async (transaction) => {
//       const userRef = doc(db, "Fines", userId);
//       const fineRef = doc(db, "Fines", userId, "fines", fineId);

//       // 1️⃣ READS: Read user doc & all fines first
//       const userDoc = await transaction.get(userRef);
//       if (!userDoc.exists()) throw new Error("User fine record not found");

//       const finesCollection = collection(db, "Fines", userId, "fines");
//       const finesSnapshot = await getDocs(finesCollection);

//       // Determine week/year of deleted fine
//       let deletedFineWeek = null;
//       let deletedFineYear = null;
//       finesSnapshot.forEach((docSnap) => {
//         if (docSnap.id === fineId && docSnap.data().date) {
//           const fineDate = docSnap.data().date?.toDate
//             ? docSnap.data().date.toDate()
//             : new Date(docSnap.data().date);
//           const { week, year } = getISOWeekYear(fineDate);
//           deletedFineWeek = week;
//           deletedFineYear = year;
//         }
//       });

//       // Collect all fines of that week excluding the deleted fine
//       const weekFines = finesSnapshot.docs
//         .filter((docSnap) => {
//           if (docSnap.id === fineId) return false;
//           const fineData = docSnap.data();
//           if (!fineData.date) return false;
//           const { week, year } = getISOWeekYear(
//             fineData.date?.toDate ? fineData.date.toDate() : new Date(fineData.date)
//           );
//           return week === deletedFineWeek && year === deletedFineYear;
//         })
//         .sort(
//           (a, b) =>
//             (a.data().createdAt?.seconds || 0) -
//             (b.data().createdAt?.seconds || 0)
//         );

//       // 2️⃣ WRITES: Now perform all writes
//       // Delete the fine
//       transaction.delete(fineRef);

//       // Update user totals
//       const userData = userDoc.data();
//       const updatedTotal = Math.max(0, (userData.TotalFine || 0) - parsedAmount);
//       const updatedPending =
//         status === "Pending"
//           ? Math.max(0, (userData.PendingFine || 0) - parsedAmount)
//           : userData.PendingFine || 0;

//       transaction.update(userRef, {
//         TotalFine: updatedTotal,
//         PendingFine: updatedPending,
//         lastUpdated: serverTimestamp(),
//       });

//       // Adjust first fine of week if needed
//       if (weekFines.length > 0) {
//         const firstFineRef = doc(db, "Fines", userId, "fines", weekFines[0].id);
//         const firstFineData = weekFines[0].data();
//         if (firstFineData.amount > 100) {
//           transaction.update(firstFineRef, { amount: 100 });
//         }
//       }

//       // Update global summary
//       const usersCollection = collection(db, "Fines");
//       const usersSnapshot = await getDocs(usersCollection);

//       let totalFinesAmount = 0;
//       let pendingFinesAmount = 0;
//       usersSnapshot.forEach((docSnap) => {
//         const d = docSnap.data();
//         totalFinesAmount += d.TotalFine || 0;
//         pendingFinesAmount += d.PendingFine || 0;
//       });

//       const collectedAmount = totalFinesAmount - pendingFinesAmount;
//       const historyRef = doc(db, "fineAmountHistory", "latest");

//       transaction.set(
//         historyRef,
//         {
//           totalFinesAmount,
//           pendingFinesAmount,
//           collectedAmount,
//           updatedAt: serverTimestamp(),
//         },
//         { merge: true }
//       );
//     });

//     Swal.fire("Deleted", "Fine deleted successfully", "success");
//     fetchData && fetchData();
//   } catch (error) {
//     Swal.fire("Error", error.message, "error");
//   }
// };
// /* ================= HELPER ================= */
// function getISOWeekYear(date) {
//   const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
//   const dayNum = d.getUTCDay() || 7;
//   d.setUTCDate(d.getUTCDate() + 4 - dayNum);
//   const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
//   const weekNum = Math.ceil(((d - yearStart) / 86400000 + 1) / 7);
//   return { week: weekNum, year: d.getUTCFullYear() };
// }




// import {
//   doc,
//   getDoc,
//   setDoc,
//   deleteDoc,
//   collection,
//   getDocs,
//   serverTimestamp,
// } from "firebase/firestore";
// import Swal from "sweetalert2";
// import { db } from "../firebase";

// /* ================= HANDLE DELETE FINE ================= */
// export const handleDeleteFine = async (userId, fineId, amount, status, fetchData) => {
//   try {
//     const docRef = doc(db, "appSetupAction", "1");
//     const docSnap = await getDoc(docRef);
//     const allowDisallow = docSnap.exists() ? docSnap.data().allowDisallow : false;

//     // Decide which delete method to use
//     await deleteFine(userId, fineId, amount, status, fetchData, allowDisallow);
//   } catch (error) {
//     console.error("Error in handleDeleteFine:", error);
//   }
// };

// /* ================= DELETE FINE (ADD-LIKE LOGIC) ================= */
// export const deleteFine = async (userId, fineId, amount, status, fetchData, ruleWise = false) => {
//   const result = await Swal.fire({
//     title: "Delete Fine",
//     text: "Are you sure you want to delete this fine?",
//     icon: "warning",
//     showCancelButton: true,
//     confirmButtonText: "Yes, delete it",
//     confirmButtonColor: "#d33",
//   });

//   if (!result.isConfirmed) return;

//   try {
//     const parsedAmount = parseFloat(amount) || 0;
//     const userRef = doc(db, "Fines", userId);
//     const userDoc = await getDoc(userRef);
//     const prev = userDoc.exists() ? userDoc.data() : {};

//     // 1️⃣ Update user totals like Add method
//     await setDoc(
//       userRef,
//       {
//         TotalFine: Math.max(0, (prev.TotalFine || 0) - parsedAmount),
//         PendingFine:
//           status === "Pending"
//             ? Math.max(0, (prev.PendingFine || 0) - parsedAmount)
//             : prev.PendingFine || 0,
//         createdAt: prev.createdAt || serverTimestamp(),
//         lastUpdated: serverTimestamp(),
//       },
//       { merge: true }
//     );

//     // 2️⃣ Delete the fine from subcollection
//     await deleteDoc(doc(userRef, "fines", fineId));

//     // 3️⃣ RuleWise adjustment if enabled
//     if (ruleWise) {
//       const finesSnapshot = await getDocs(collection(db, "Fines", userId, "fines"));
//       if (finesSnapshot.docs.length > 0) {
//         const firstFine = finesSnapshot.docs
//           .sort((a, b) => (a.data().createdAt?.seconds || 0) - (b.data().createdAt?.seconds || 0))[0];
//         if (firstFine.data().amount > 100) {
//           await setDoc(
//             doc(db, "Fines", userId, "fines", firstFine.id),
//             { amount: 100 },
//             { merge: true }
//           );
//         }
//       }
//     }

//     // 4️⃣ Update global summary (fineAmountHistory/latest)
//     await updateGlobalHistory();

//     // Refresh UI or re-fetch
//     fetchData && fetchData();
//     Swal.fire("Deleted", "Fine deleted successfully", "success");
//   } catch (error) {
//     Swal.fire("Error", error.message, "error");
//   }
// };

// /* ================= GLOBAL HISTORY ================= */
// const updateGlobalHistory = async () => {
//   try {
//     const usersSnapshot = await getDocs(collection(db, "Fines"));
//     let totalFinesAmount = 0;
//     let pendingFinesAmount = 0;

//     usersSnapshot.forEach((docSnap) => {
//       const d = docSnap.data();
//       totalFinesAmount += d.TotalFine || 0;
//       pendingFinesAmount += d.PendingFine || 0;
//     });

//     await setDoc(
//       doc(db, "fineAmountHistory", "latest"),
//       {
//         totalFinesAmount,
//         pendingFinesAmount,
//         collectedAmount: totalFinesAmount - pendingFinesAmount,
//         updatedAt: serverTimestamp(),
//       },
//       { merge: true }
//     );
//   } catch (error) {
//     console.error("Error updating global history:", error);
//   }
// };



import {
  doc,
  
  setDoc,
  deleteDoc,
  collection,
  getDocs,
  serverTimestamp,
} from "firebase/firestore";
import Swal from "sweetalert2";
import { db } from "../firebase";

/* ================= HANDLE DELETE FINE ================= */
export const handleDeleteFine = async (userId, fineId, fetchData, ruleWise = false) => {
  // Make fetchData safe
  fetchData = typeof fetchData === "function" ? fetchData : () => {};

  try {
    const result = await Swal.fire({
      title: "Delete Fine",
      text: "Are you sure you want to delete this fine?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it",
      confirmButtonColor: "#d33",
    });

    if (!result.isConfirmed) return;

    const userRef = doc(db, "Fines", userId);

    // 1️⃣ Delete the fine from subcollection
    await deleteDoc(doc(userRef, "fines", fineId));

    // 2️⃣ RuleWise adjustment if enabled
    if (ruleWise) {
      const finesSnapshot = await getDocs(collection(db, "Fines", userId, "fines"));
      if (finesSnapshot.docs.length > 0) {
        const firstFine = finesSnapshot.docs
          .sort((a, b) => (a.data().createdAt?.seconds || 0) - (b.data().createdAt?.seconds || 0))[0];
        if ((firstFine.data().amount || 0) > 100) {
          await setDoc(
            doc(db, "Fines", userId, "fines", firstFine.id),
            { amount: 100 },
            { merge: true }
          );
        }
      }
    }

    // 3️⃣ Recalculate user totals
    const finalSnapshot = await getDocs(collection(db, "Fines", userId, "fines"));
    let total = 0;
    let pending = 0;

    finalSnapshot.forEach((docSnap) => {
      const data = docSnap.data();
      const amt = Number(data.amount) || 0;
      total += amt;
      if (data.status === "Pending") pending += amt;
    });

    await setDoc(
      userRef,
      {
        TotalFine: total,
        PendingFine: pending,
        lastUpdated: serverTimestamp(),
      },
      { merge: true }
    );

    // 4️⃣ Update global summary
    await updateGlobalHistory();

    // 5️⃣ Refresh UI
    fetchData();
    Swal.fire("Deleted", "Fine deleted successfully", "success");
  } catch (error) {
    console.error("Error deleting fine:", error);
    Swal.fire("Error", error.message, "error");
  }
};

/* ================= ADD FINE ================= */
export const addFine = async (userId, fineData, fetchData) => {
  // Make fetchData safe
  fetchData = typeof fetchData === "function" ? fetchData : () => {};

  try {
    const userRef = doc(db, "Fines", userId);
    const finesRef = collection(userRef, "fines");
    const newFineRef = doc(finesRef);

    // 1️⃣ Add fine to subcollection
    await setDoc(newFineRef, {
      ...fineData,
      amount: Number(fineData.amount) || 0,
      status: fineData.status || "Pending",
      createdAt: serverTimestamp(),
    });

    // 2️⃣ Recalculate user totals
    const finesSnapshot = await getDocs(finesRef);
    let total = 0;
    let pending = 0;

    finesSnapshot.forEach((docSnap) => {
      const data = docSnap.data();
      const amt = Number(data.amount) || 0;
      total += amt;
      if (data.status === "Pending") pending += amt;
    });

    await setDoc(
      userRef,
      {
        TotalFine: total,
        PendingFine: pending,
        lastUpdated: serverTimestamp(),
      },
      { merge: true }
    );

    // 3️⃣ Update global summary
    await updateGlobalHistory();

    // 4️⃣ Refresh UI
    fetchData();
    Swal.fire("Added", "Fine added successfully", "success");
  } catch (error) {
    console.error("Error adding fine:", error);
    Swal.fire("Error", error.message, "error");
  }
};

/* ================= GLOBAL HISTORY ================= */
const updateGlobalHistory = async () => {
  try {
    const usersSnapshot = await getDocs(collection(db, "Fines"));
    let totalFinesAmount = 0;
    let pendingFinesAmount = 0;

    usersSnapshot.forEach((docSnap) => {
      const d = docSnap.data();
      totalFinesAmount += d.TotalFine || 0;
      pendingFinesAmount += d.PendingFine || 0;
    });

    await setDoc(
      doc(db, "fineAmountHistory", "latest"),
      {
        totalFinesAmount,
        pendingFinesAmount,
        collectedAmount: totalFinesAmount - pendingFinesAmount,
        updatedAt: serverTimestamp(),
      },
      { merge: true }
    );
  } catch (error) {
    console.error("Error updating global history:", error);
  }
};